import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    ActionListItemComponent,
    AvatarComponent,
    DictionaryComponent,
    DictionaryItemComponent,
    DictionaryItemContentDirective,
    DictionaryItemLabelDirective,
    DropListA11yDirective,
    DropListModule,
    ExpandableComponent,
    StatusTagComponent,
} from '@exl-ng/mulo-common';

import { SharedModule } from '../../../shared/shared.module';
import { CitationsModule } from '../../citations/citations.module';
import { EntityLocalFieldsComponent } from './entity-local-fields.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        AvatarComponent,
        ActionListItemComponent,
        CitationsModule,
        DropListModule,
        DropListA11yDirective,
        StatusTagComponent,
        DictionaryComponent,
        DictionaryItemComponent,
        DictionaryItemLabelDirective,
        DictionaryItemContentDirective,
        ExpandableComponent,
        EntityLocalFieldsComponent,
    ],
    exports: [EntityLocalFieldsComponent],
})
export class EntityLocalFieldsModule {}
